import { useCallback, useEffect } from 'react'
import { ApiCustomer } from '@vend/types'
import { customerGroupsStore } from '../../../../../../factories/database/customer-groups-store'
import {
  CurrentView,
  useLineItemFulfillmentContext,
} from '../LineItemFulfillmentContext'
import { useVdFeatureManager } from '../../../../../../ng-compat/hooks'
import { detectCustomerFieldFromQuery } from '../../../../../../functions/customer'
import { generateAddressDetailsFromCustomer } from '../../fulfillmentHelper'

export const useLineItemFulfillmentSaleCustomer = () => {
  const vdFeatureManager = useVdFeatureManager()
  const shouldShowGroup = vdFeatureManager.get('customer_groups')

  const {
    currentCustomer,
    setCurrentCustomer,
    customerGroup,
    setCustomerGroup,
    setOriginalCustomer,
    setCurrentView,
    setIsCurrentCustomerRemoved,
    fulfilmentDetails,
    setFulfilmentDetails,
  } = useLineItemFulfillmentContext()

  const setupCustomerGroup = useCallback(async () => {
    if (currentCustomer?.customer_group_id) {
      const groupEntity = await customerGroupsStore.get(
        currentCustomer.customer_group_id
      )
      if (groupEntity) {
        setCustomerGroup({
          id: groupEntity.id,
          name: groupEntity.name,
        })
      }
    }
  }, [currentCustomer, setCustomerGroup])

  if (shouldShowGroup && currentCustomer && !customerGroup) {
    setupCustomerGroup()
  }

  useEffect(() => {
    if (shouldShowGroup && currentCustomer) {
      setupCustomerGroup()
    } else {
      setCustomerGroup(undefined)
    }
  }, [shouldShowGroup, currentCustomer, setupCustomerGroup, setCustomerGroup])

  const updateFulfillmentDetails = (customer: ApiCustomer) => {
    const newFulfillmentDetail = {
      ...fulfilmentDetails,
      ...generateAddressDetailsFromCustomer(customer),
    }

    setFulfilmentDetails(newFulfillmentDetail)
  }

  const onAddNewCustomer = () => {
    const inputNode: HTMLInputElement | null = document.querySelector(
      '.vd-popover-content .vd-autocomplete-input'
    )
    const newName = inputNode?.value

    if (newName) {
      const customer = detectCustomerFieldFromQuery(newName)
      const newApiCustomer: ApiCustomer = {
        first_name: customer.firstName,
        last_name: customer.lastName,
        email: customer.email,
        mobile: customer.mobile,
      } as ApiCustomer
      setCurrentCustomer(prevState => ({
        ...prevState,
        ...newApiCustomer,
      }))
      setOriginalCustomer(null)
      setCurrentView(CurrentView.CREATE_NEW_CUSTOMER)
      updateFulfillmentDetails(newApiCustomer)
    }
  }

  const onSelectCustomer = (customer: ApiCustomer | null) => {
    if (!customer) {
      return
    }
    setCurrentCustomer(customer)
    setOriginalCustomer(customer)
    setCurrentView(CurrentView.REVIEW_CONTACT_INFO)
    updateFulfillmentDetails(customer)
  }

  const onRemoveCustomer = () => {
    setCurrentCustomer(null)
    setOriginalCustomer(null)
    setIsCurrentCustomerRemoved(true)
    setCurrentView(CurrentView.ADD_CUSTOMER)
    updateFulfillmentDetails({} as ApiCustomer)
  }

  return {
    onAddNewCustomer,
    onSelectCustomer,
    onRemoveCustomer,
  }
}
